import type { Mark } from '../data/types';
import { formatTime } from './time';

export const MARK_KIND: Record<Mark['kind'], string> = { loop: 'Loop', stab: 'Stab', bass: 'Bass alone', vocal: 'Vocal', break: 'Break' };
const ROOTS = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

/** "Loop, 0:32 to 0:40, 92 BPM, F minor": commas, never middle dots (fail list 4). */
export function markMeta(m: Mark): string {
  const parts = [MARK_KIND[m.kind], `${formatTime(m.inS)} to ${formatTime(m.outS)}`];
  if (m.bpm) parts.push(`${m.bpm} BPM`);
  if (m.keyRoot !== undefined) parts.push(`${ROOTS[m.keyRoot] ?? '?'} ${m.minor ? 'minor' : 'major'}`);
  return parts.join(', ');
}
